import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';

export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  state: {
    foreignTradeTemplateData: {
      countryName: '',
      endPeriodYear: 0,
      previousPeriodYear: 0,
      totalTradeValue: 0,
      totalTradeDynamics: 0,
      exportValue: 0,
      exportDynamics: 0,
      importValue: 0,
      importDynamics: 0,
      balanceValue: 0,
      balanceChangeType: '',
      tekChangeType: '',
      withoutTekTotalTradeValue: 0,
      withoutTekTotalTradeDynamics: 0,
      withoutTekExportValue: 0,
      withoutTekExportDynamics: 0,
      withoutTekBalanceValue: 0,
      withoutTekBalanceDynamics: '',
    },
    foreignTradeTable: {
      periods: [],
      items: [],
    },
    exportStructureTable: {
      firstItemNumber: 1,
      itemCount: 1,
      items: [],
      itemsTotal: 1,
      pageNumber: 1,
      pageSize: 20,
      pagesTotal: 1,
    },
    importStructureTable: {
      firstItemNumber: 1,
      itemCount: 1,
      items: [],
      itemsTotal: 1,
      pageNumber: 1,
      pageSize: 20,
      pagesTotal: 1,
    },
    exportProductsTable: {
      firstItemNumber: 1,
      itemCount: 1,
      items: [],
      itemsTotal: 1,
      pageNumber: 1,
      pageSize: 20,
      pagesTotal: 1,
    },
    importProductsTable: {
      firstItemNumber: 1,
      itemCount: 1,
      items: [],
      itemsTotal: 1,
      pageNumber: 1,
      pageSize: 20,
      pagesTotal: 1,
    },
  },
};
